<a
  *ngIf="!isLoggedIn"
  [href]="inHostContext ? '#overlay/login' : (loginUrl$ | async)"
  shrdUicButton
  [class.rememberme-active]="inHostContext"
  [attr.data-sso]="inHostContext || null"
  [variant]="variant"
  [shrdUtcTrackEvent]="trackEvent"
  [ngClass]="additionalClasses"
  (click)="clickHandler.emit()"
>
  <shrd-uic-svg-icon *ngIf="icon" [icon]="icon" />
  <span *ngIf="text">
    {{ text }}
  </span>
</a>
